<template>
   <div class="step" :class="stepClass" @click="emitClick()">
      <button class="step__btn" :disabled="disabled">
        <span class="step__circle">{{ index }}</span>
      </button>
      <div class="step__label">{{ label }}</div>
    </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: '',
      required: false
    },
    index: {
      type: [Number, String],
      required: true
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    active: {
      type: Boolean,
      default: false,
      required: false
    }
  },

  computed: {
    stepClass() {
      if (!this.disabled)
        return this.active ? 'step--active' : ''
      return 'step--disabled'
    }
  },

  methods: {
    emitClick: function() {
      if (!this.disabled)
        this.$emit('change-step')
    }
  }
}
</script>

<style lang="scss">
$step-color: #0e5b95;
$step-grey: #b1c2c8;
$step-white: #ffffff;
$step-border: 2px solid $step-color; //7px double $step-color;
$step-shadow: inset 0 0 0 2px $step-white, inset 0 0 0 4px $step-color;
$disabled-step-shadow: inset 0 0 0 2px $step-white, inset 0 0 0 4px $step-grey;
$active-step-shadow: inset 0 0 0 2px $step-white;
$font-size: 1.5rem;
$label-font-size: 1rem;
$circle-size: 4rem;
$fast-animated: .4s all;

.step {
  position: relative;
  display: flex;
  flex: 0 0 25%;
  flex-flow: row wrap;
  justify-content: center;
  cursor: pointer;
  border: 0;
  outline: 0;
  background-color: transparent;
  width: 100%;

  &__btn {
    &:hover, &:focus {
      background: transparent;
    }
  }

  &:first-child {
    .step__btn {
      &::before {
        border: 0;
        content: none;
        display: none;
      }
    }
  }

  &--active {
    .step__circle {
      background-color: $step-color;
      box-shadow: $active-step-shadow;
      color: $step-white;
    }
  }

  &--disabled {
    cursor: not-allowed;

    .step__btn {
      &::before {
        border-color: $step-grey;
      }
    }

    .step__circle {
      border-color: $step-grey;
      box-shadow: $disabled-step-shadow;
      color: $step-grey;
    }

    .step__label {
      color: $step-grey;
      display: inline-block;
    }
  }

  &__btn {
    appearance: none;
    background: none;
    border-width: 0;
    border-color: $step-color;
    box-shadow: none;
    outline: none;
    position: relative;
    width: 100%;

    &::before {
      content: "";
      border-width: 1px;
      border-style: solid;
      border-color: inherit;
      display: inline-block;
      position: absolute;
      top: 50%;
      left: -50%;
      transform: translate(0, -50%);
      transform-origin: 0;
      transition: $fast-animated;
      width: 100%;
    }

    &:hover {
      background: none;
    }
  }

  &__circle {
    align-items: center;
    background-color: $step-white;
    border: $step-border;
    border-radius: 100%;
    box-shadow: $step-shadow;
    color: $step-color;
    display: flex;
    flex-flow: row wrap;
    font-size: $font-size;
    height: $circle-size;
    justify-content: center;
    position: relative;
    margin: 0 auto;
    width: $circle-size;
    z-index: 1;
  }

  &__label {
    text-align: center;
    flex: 1 0 100%;
    color: $step-color;
    font-size: $label-font-size;
    padding: .5rem 0;
  }
}
</style>
